import { Controller } from "@hotwired/stimulus"

// inline 비교 표 토글 — 같은 화면 안에서 비교 표 표시/숨김.
// inline-edit / inline-complete 와 동일 패턴.
//   <div data-controller="inline-compare">
//     <button data-action="click->inline-compare#toggle">비교 보기</button>
//     <div data-inline-compare-target="form" class="hidden">...비교 표...</div>
//   </div>
export default class extends Controller {
  static targets = ["form"]

  toggle(event) {
    if (event) event.preventDefault()
    this.formTarget.classList.toggle("hidden")
    if (!this.formTarget.classList.contains("hidden")) {
      this.formTarget.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  hide() {
    this.formTarget.classList.add("hidden")
  }
}
